import { Achievement } from './achievement.shared.model.js';
export var GuideStyle = /*#__PURE__*/function (GuideStyle) {
  GuideStyle[GuideStyle["DEFAULT"] = 1] = "DEFAULT";
  GuideStyle[GuideStyle["CARD"] = 2] = "CARD";
  return GuideStyle;
}(GuideStyle || {});
export var GuideId = /*#__PURE__*/function (GuideId) {
  GuideId["MEASURE"] = "measure";
  GuideId["OVULATION"] = "ovulation";
  GuideId["CERVICAL_MUCUS"] = "cervicalmucus";
  GuideId["CERVICAL_MUCUS_PREGNANT"] = "discharge";
  GuideId["LH"] = "lh";
  GuideId["EFFECTIVENESS"] = "effectiveness";
  GuideId["BREAST_CHECK"] = "breast";
  GuideId["UEBE"] = "uebe";
  GuideId["MENSTRUAL_CYCLE"] = "menstrualcycle";
  GuideId["HBC"] = "hbc";
  GuideId["OURA"] = "oura";
  GuideId["T3"] = "T3";
  GuideId["APPLE_WATCH"] = "applewatch";
  GuideId["B1"] = "b1";
  GuideId["MEASURING_OVERNIGHT"] = "measuringovernight";
  GuideId["CHILDBIRTH_EXPECTATIONS"] = "childbirthexpectations";
  GuideId["CHILDBIRTH_SEXLIFE"] = "childbirthsexlife";
  GuideId["CHILDBIRTH_SLEEP"] = "childbirthsleep";
  GuideId["PELVIC_FLOOR"] = "pelvicfloor";
  GuideId["PREG_LOSS"] = "pregnancy-loss";
  GuideId["UNPLANNED_PREG"] = "unplanned-pregnancy";
  GuideId["LATE_PERIODS"] = "late-periods";
  GuideId["HBC_QUIT"] = "hbc-quit";
  GuideId["PP_FERTILITY"] = "pp-fertility";
  GuideId["CHILDBIRTH_PREPARE"] = "childbirth-prepare";
  GuideId["PP_MENTAL_HEALTH"] = "pp-mental-health";
  GuideId["PP_BACK_TO_WORK"] = "pp-work";
  GuideId["FEEDING_BABY"] = "feeding-baby";
  return GuideId;
}(GuideId || {});
export const ACHIEVEMENT_BY_GUIDE = {
  [GuideId.MEASURE]: Achievement.readGuideMeasure,
  [GuideId.OVULATION]: Achievement.readGuideOvulation,
  [GuideId.CERVICAL_MUCUS]: Achievement.readGuideCervicalMucus,
  [GuideId.CERVICAL_MUCUS_PREGNANT]: Achievement.readGuideCervicalMucusPregnant,
  [GuideId.LH]: Achievement.readGuideLh,
  [GuideId.EFFECTIVENESS]: Achievement.readGuideEffectiveness,
  [GuideId.BREAST_CHECK]: Achievement.readGuideBreastCheck,
  [GuideId.UEBE]: Achievement.readGuideUebe,
  [GuideId.HBC]: Achievement.readGuideHbc,
  [GuideId.MENSTRUAL_CYCLE]: Achievement.readGuideMenstrualCycle,
  [GuideId.OURA]: Achievement.readGuideOura,
  [GuideId.T3]: Achievement.readGuideT3,
  [GuideId.APPLE_WATCH]: Achievement.readGuideAppleWatch,
  [GuideId.B1]: Achievement.readGuideB1,
  [GuideId.MEASURING_OVERNIGHT]: Achievement.readGuideMeasuringOvernight,
  [GuideId.CHILDBIRTH_EXPECTATIONS]: Achievement.readGuideChildbirthExpectations,
  [GuideId.CHILDBIRTH_SEXLIFE]: Achievement.readGuideChildbirthSexlife,
  [GuideId.CHILDBIRTH_SLEEP]: Achievement.readGuideChildbirthSleep,
  [GuideId.PELVIC_FLOOR]: Achievement.readGuidePelvicFloor,
  [GuideId.PREG_LOSS]: Achievement.cardsPregLoss,
  [GuideId.UNPLANNED_PREG]: Achievement.cardsUnplannedPreg,
  [GuideId.LATE_PERIODS]: Achievement.cardsLatePeriods,
  [GuideId.HBC_QUIT]: Achievement.cardsHbcQuit,
  [GuideId.PP_FERTILITY]: Achievement.cardsPpFertility,
  [GuideId.CHILDBIRTH_PREPARE]: Achievement.cardsChildbirthPrepare,
  [GuideId.PP_MENTAL_HEALTH]: Achievement.cardsPpMentalHealth,
  [GuideId.PP_BACK_TO_WORK]: Achievement.cardsPpBackToWork,
  [GuideId.FEEDING_BABY]: Achievement.cardsFeedingBaby
};